var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 100,
    viewBox: "0 0 180 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.716 0H17.284C7.73831 0 0 7.73831 0 17.284V82.716C0 92.2617 7.73831 100 17.284 100H162.716C172.262 100 180 92.2617 180 82.716V17.284C180 7.73831 172.262 0 162.716 0Z",
    fill: "#1565BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5077 42.0254C92.4244 48.5727 98.3608 52.2261 102.833 54.3985C107.427 56.6271 108.97 58.0565 108.952 60.0498C108.918 63.1 105.287 64.4463 101.89 64.4986C95.9626 64.5901 92.5162 62.9033 89.7764 61.6274L87.6412 71.5877C90.3901 72.8504 95.4801 73.9517 100.758 74C113.148 74 121.254 67.903 121.298 58.4499C121.347 46.4526 104.652 45.7885 104.766 40.4261C104.805 38.8 106.362 37.0649 109.772 36.6237C111.46 36.4008 116.12 36.2302 121.404 38.6556L123.477 29.0189C120.636 27.9876 116.984 27 112.438 27C100.776 27 92.5738 33.18 92.5077 42.0254ZM143.403 27.8301C141.14 27.8301 139.234 29.1457 138.383 31.1646L120.685 73.2922H133.065L135.529 66.5044H150.658L152.088 73.2922H163L153.477 27.8301H143.403ZM145.135 40.1111L148.708 57.1826H138.923L145.135 40.1111ZM77.4965 27.8306L67.7373 73.2916H79.5353L89.29 27.8295L77.4965 27.8306ZM60.0432 27.8306L47.7632 58.7734L42.7958 32.4631C42.2129 29.526 39.9112 27.8301 37.355 27.8301H17.2812L17 29.1502C21.1211 30.0417 25.8033 31.4795 28.6401 33.018C30.3761 33.9578 30.8711 34.7793 31.4415 37.0125L40.8499 73.2922H53.3175L72.4321 27.8301L60.0432 27.8306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d51899cf38d52c84438fb1dd3c00b97d.svg";
export { ForwardRef as ReactComponent };